/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SealogLoweringRecordDeploymentDiscoveryConfig = {
    type: SealogLoweringRecordDeploymentDiscoveryConfig.type;
    /**
     *
     * Regular expression pattern to locate Sealog lowering record files.
     *
     * Pattern should match paths to loweringRecord.json files.
     * Example: "Vehicles/Chimaera/.*loweringRecord.json"
     *
     */
    pattern: string;
};

export namespace SealogLoweringRecordDeploymentDiscoveryConfig {

    export enum type {
        SEALOG_LOWERING_RECORD = 'sealog_lowering_record',
    }


}

